__turbopack_context__.v({
  "breadcrumbDot": "SlideBreadcrumbs-module__e5WItq__breadcrumbDot",
  "slideBreadcrumbs": "SlideBreadcrumbs-module__e5WItq__slideBreadcrumbs",
});
